<script>
import ParticipantsTable from "./Table.vue";
import ParticipantBulkActionForm from "../AAA_TO_REFACTOR/ParticipantBulkActionForm.vue";
import Multiselect from "vue-multiselect";
import CustomOptionGroup from "../Utility/CustomOptions/CustomOptionGroup.vue";
import CustomOption from "../Utility/CustomOptions/CustomOption.vue";

export default {
    components: {
        ParticipantsTable,
        ParticipantBulkActionForm,
        Multiselect,
        CustomOptionGroup,
        CustomOption,
    },
    props: {
        initial: {
            type: String,
            required: false
        },
        registrationCategories: {
            type: Object,
            required: false,
        },
        participantStatuses: {
            type: Object,
            required: false,
        },
        /**
         * The threshold of records before a background download is mandated
         */
        backgroundThreshold:{
            type: String,
            required: false,
            default: "1000"
        }
    },
    data() {
        return {
            query: '', //The free string query i.e. name
            bulk: [], //The list of participant IDs when using the bulk search function
            participant_status: [],
            registration_category: [],
            queryString: '', //The calculated query string
            selectedIds: [],
            bulkMode: false,
            rows: 0, //The count of rows
            inViewIds: [], //The list of IDs,
            exportUrl: '#',
            sendEmail: false,
        }
    },
    mounted() {
        this.setDataFromQuery()
    },
    methods: {
        deleteQueryParam(searchParams, key) {
            searchParams.delete(key);

            if(Array.isArray(this[key])){
                for (let i = 0; i <= 200; i++) { //20 - currently on admin/participant/occasions/XXX we add registration_category[0]=1231&registration_category[1]=XX.....
                    let queryKey = key + '[' + i + ']';
                    searchParams.delete(queryKey);
                }
            }

            return searchParams;
        },
        uploadValues(event) {
            let file = event.target.files[0];
            let reader = new FileReader();
            reader.readAsText(file);
            reader.onload = (evt) => {
                //TODO - Clean the string here!
                Object.assign(this, {
                    bulk: evt.target.result
                        .split("\n")
                        .filter(string => string.length)//Removes any empty strings from the array which makes the count wrong.
                        .map(idOrRef => idOrRef.replace('#', '')),//Turns any 'refs' into 'ids'.
                });
            };
            this.$refs.bulkupload.value = null;
        },
        setDataFromQuery() { //Used when the page is first loaded to set the inital query from the URL query string
            let urlComponents = (this.parseQuery(decodeURIComponent(this.initial)));

            Object.keys(urlComponents).map((key, item) => {
                let value = urlComponents[key];
                if (key.includes('registration_category')) {
                    this.registration_category.push(value);
                } else if (key.includes('participant_status')) {
                    this.participant_status.push(value);
                }
            });
        },
        updated(payload) { //When the table is updated after the search filter changes
            this.inViewIds = payload.inViewIds;
            this.rows = payload.rows;
        },
        selectAllIds(ids) { //Select all ID's in view
            this.selectedIds = ids;
        },
        clearSelectedIds() { //Clear the selected ID's
            this.selectedIds = [];
        },
        parseQuery(queryString) {
            var params = {}, queries, temp, i, l;

            // Split into key/value pairs
            queries = queryString.split("&");

            // Convert the array of strings into an object
            for (i = 0, l = queries.length; i < l; i++) {
                temp = queries[i].split('=');
                params[temp[0]] = temp[1];
            }

            return params;
        },
        buildQuery(field) {

            let searchParams = new URLSearchParams(window.location.search)
            searchParams = this.deleteQueryParam(searchParams, field);
            let currentQuery = window.location.pathname + '?' + searchParams.toString();

            if (Array.isArray(this[field])) {
                this[field].forEach((status, index) => {
                    if (typeof status === 'object') {
                        currentQuery += `&${field}[${index}]=${status.value}`
                    } else {
                        currentQuery += `&${field}[${index}]=${status}`
                    }
                })
            } else {
                currentQuery += `&${field}=${this.query}`
            }

            history.replaceState({}, null, currentQuery);
            searchParams = new URLSearchParams(window.location.search)
            this.queryString = searchParams.toString();

            const currentUrl = window.location.href;
            if (currentUrl.includes('reports/')) {
                this.exportUrl = currentUrl.replace(
                    'participant-report',
                    'export-participant-report'
                );
            } else {
                this.exportUrl = currentUrl.replace(
                    'participant-report',
                    'reports/export-participant-report'
                );
            }
        },
        showConfirmationMessage(event, confirmationMessage) {
            if (this.sendEmail || confirm(confirmationMessage)) {
                return;
            }

            event.preventDefault(); // Prevent if confirmation dialog is cancelled
        },
        print: function (ref) {
            const printContent = this.$refs[ref].innerHTML;
            const originalContent = document.body.innerHTML;

            const style = `<style>@page {size: landscape;}</style>`;

            document.body.innerHTML = style + printContent;
            window.print();
            document.body.innerHTML = originalContent;
            window.location.reload();
        },
    },
    watch: {
        bulkMode(newVal, oldVal) {
            this.query = '';
            this.selectedIds = [];

            if ((newVal === false)) {
                this.buildQuery('q');
                this.bulk = [];
            }
        },
        query() {
            this.buildQuery('q');
        },
        registration_category() {
            this.buildQuery('registration_category');
        },
        participant_status() {
            this.buildQuery('participant_status');
        },
        bulk() {

            if (!this.bulk.length) {
                return;
            }

            let currentQuery = window.location.pathname + '?';

            this.bulk.forEach((status, index) => {
                currentQuery += `&ids[${index}]=${status}`
            })

            console.log('current query: ', currentQuery);

            this.queryString = currentQuery;
        },
        rows(newVal) {
            this.sendEmail = newVal > this.backgroundThreshold;
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Participants/TableContainer.vue